import { createSlice } from '@reduxjs/toolkit';

const initialState: Cart = {
  cartId: '',
  cartHash: '',
  storeId: '',
  storeName: '',
  shippingAddress: null as Address | null,
  storeLogo: '',
  user: {
    email: '',
  },
  returnUrl: '',
  currency: 'BRL',
  products: [],
  discounts: [],
  total: '0',
  subtotal: '0',
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    initialize: (state, action) => action.payload,
    update: (state, action) => ({ ...state, ...action.payload }),
  },
});

export const { initialize, update } = cartSlice.actions;

export default cartSlice.reducer;
